"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RegistrationService = void 0;
const BaseRestService_1 = __importDefault(require("../BaseRestService"));
const utils_1 = require("@sqvr/utils");
class RegistrationService extends BaseRestService_1.default {
  constructor() {
    super(...arguments);
    this.basePath = '';
    this.getInnData = (request, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      return this.send(utils_1.GET, '', `/autocomplete/company?query=${request.inn}`, Object.assign({}, options), requestOptions);
    });
  }
}
exports.RegistrationService = RegistrationService;
const registrationService = new RegistrationService();
exports.default = registrationService;